<template>
  <tr :class="rowClass">
    <td>
      {{ text }}
    </td>
    <td>
      <b-upload @input="uploadFile()" v-model="file" :accept="accept">
        <b-button
          class="bulma-upload-button"
          :icon-left="icon"
          :loading="loading"
        />
      </b-upload>
    </td>
    <td>
      <b-tag
        v-for="(file, index) in value"
        :key="index"
        closable
        aria-close-label="Close tag"
        @close="deleteFileByIndex(index)"
        ><b-checkbox
          @input="toggleSharedValue(index, file.shared || false)"
          :value="file.shared || false"
        /><a :href="file.url || file.s3ObjectLocation" target="_blank">{{
          file.name
        }}</a>
        {{ fromUnix(file.createdAt) }}</b-tag
      >
    </td>
    <slot></slot>
  </tr>
</template>

<script>
import S3 from 'aws-s3'
import moment from 'moment'

export default {
  props: {
    bucketName: {
      type: String,
      default: 'ecobanka-dev'
    },
    region: {
      type: String,
      default: 'eu-west-1'
    },
    rowClass: {
      type: String,
      default: 'default'
    },
    accessKeyId: {
      type: String,
      default: 'AKIA5UDDMSSXW35UBDWB'
    },
    value: {
      type: Array,
      default: () => []
    },
    secretAccessKey: {
      type: String,
      default: 'AqAdv7jtiKqrYKtOXXuKEQL0etgRJEvx5xJNM7Bm'
    },
    accept: {
      type: String,
      default:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,zip, image/jpeg,application/x-zip,video/*,.xlsx,application/octet-stream,video/mp4,application/x-zip-compressed,application/vnd.ms-excel,.xls,application/zip,image/png,application/pdf,video/x-m4v,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.rar,application/x-rar-compressed,application/octet-stream'
    },
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      file: {},
      loading: false
    }
  },
  computed: {
    config() {
      return {
        bucketName: this.bucketName,
        dirName: this.dirName,
        region: this.region,
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey
      }
    },
    dirName() {
      return Math.random()
        .toString()
        .slice(2)
    },
    S3Client() {
      return new S3(this.config)
    },
    newFileName() {
      return this.file.name.replace(/ /g, '').replace(/\.[^/.]+$/, '')
    }
  },
  methods: {
    toggleSharedValue(index, value) {
      let currentValue = this.value.slice()
      currentValue[index].shared = !value
      this.$emit('input', currentValue)
    },
    deleteFileByIndex(index) {
      const currentValue = this.value.slice()
      currentValue.splice(index, 1)
      this.$emit('input', currentValue)
    },
    fromUnix(val) {
      if (!val) {
        return ''
      }
      return moment
        .unix(val.substr(0, val.length - 3))
        .tz('Europe/Madrid')
        .format('DD-MM-YYYY, h:mm:ss a')
    },
    uploadFile() {
      let self = this
      self.loading = true
      // Fix for: https://github.com/Fausto95/aws-s3/blob/master/src/S3Client.ts
      let newFile = self.file

      if (
        newFile.name.includes('.xlsx') ||
        newFile.name.includes('.xls') ||
        newFile.name.includes('.csv') ||
        newFile.name.includes('.docx') ||
        newFile.name.includes('.doc')
      ) {
        newFile = new window.File([self.file], self.newFileName, {
          type: `${
            self.file.name.split('.')[self.file.name.split('.').length - 1]
          }/${self.file.name.split('.')[self.file.name.split('.').length - 1]}`
        })
      }

      self.S3Client.uploadFile(newFile, self.newFileName)
        .then(function(data) {
          console.log(data)
          const locationParts = data.location.split('/')
          const newFile = {
            url: data.location,
            name: locationParts[locationParts.length - 1],
            createdAt: moment()
              .valueOf()
              .toString()
          }
          const currentValue = self.value.slice()
          currentValue.push(newFile)
          self.$emit('input', currentValue)
          self.file = {}
        })
        .catch(err => console.error(err))
        .then(() => (self.loading = false))
    }
  }
}
</script>

<style scoped>
.file-name {
  height: 50px;
}

.bulma-upload-button {
  font-size: 17px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 30px !important;
  min-height: 30px !important;
  background: none !important;
  color: #d23185 !important;
}

.bulma-upload-button:hover {
  background: #d23185 !important;
  color: white !important;
}

.file-name {
  border: none;
}

tr.success {
  background-color: #5cac394a;
}

tr.danger {
  background-color: #f940404a;
}

tr.warning {
  background-color: #f9e2404a;
}

tr.info {
  background-color: #409bf94a;
}
</style>
